var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90689 28.4424L10.0733 19.0769L10.175 18.637L9.83386 18.3412L2.56733 12.0413L12.1706 11.2077L12.6207 11.1686L12.7966 10.7525L16.5268 1.92654L20.257 10.7525L20.4329 11.1686L20.883 11.2077L30.4862 12.0413L23.2197 18.3412L22.8785 18.637L22.9803 19.0769L25.1467 28.4424L16.9142 23.4762L16.5268 23.2425L16.1394 23.4762L7.90689 28.4424Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightStar);
export default __webpack_public_path__ + "static/media/LightStar.93278689a7d8d4271e779031ae173627.svg";
export { ForwardRef as ReactComponent };